import { z } from 'zod';
import { QuoteDepositType } from '@trnsact/trnsact-shared-types';
import { SaleType } from 'modules/desking';
import { SendVia, EmailOptionGroups } from '../types';

export const contactsStepSchema = z.object({
  ownerPgIds: z.array(z.string()),
  accountContactIds: z.array(z.string()),
});

export const equipmentStepSchema = z.object({
  selectedId: z.string().nullable(),
});

export const tradeInListingItemSchema = z.object({
  make: z.string().nullable(),
  year: z.string().nullable(),
  model: z.string().nullable(),
  newUsed: z.string().nullable(),
  mileage: z.number().nullable(),
  netTrade: z.number().nullable(),
  amountOwed: z.number().nullable(),
  equipmentId: z.string().nullable(),
  tradeInValue: z.number().nullable(),
  serialNumberVin: z.string().nullable(),
  actualCashValue: z.number().nullable(),
  overUnderAllowance: z.number().nullable(),
  payoffLienholder: z.string().nullable(),
  payoffAccountNumber: z.string().nullable(),
  payoffGoodThroughDate: z.string().nullable(),
});

export const pricingStepSchema = z.object({
  lineItems: z.array(z.record(z.string(), z.unknown())),
  customerDeposit: z.object({
    type: z.nativeEnum(QuoteDepositType),
    value: z.number(),
    notes: z.string(),
  }),
  tradeIn: z.array(tradeInListingItemSchema),
});

export const financeMenuStepSchema = z.object({
  isEnabled: z.boolean(),
  saleType: z.nativeEnum(SaleType),
});

const sendEmailOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
  fullName: z.string(),
  email: z.string().email(),
  title: z.string(),
  phone: z.string().optional(),
  group: z.nativeEnum(EmailOptionGroups),
});

export const reviewSendStepSchema = z.object({
  notesToBuyer: z.string().nullable(),
  sendVia: z.nativeEnum(SendVia),
  sendEmailTo: sendEmailOptionSchema.array().optional(),
  ccEmails: sendEmailOptionSchema.array().optional(),
});

export const dealBuilderFormSchema = z.object({
  contacts: contactsStepSchema,
  equipment: equipmentStepSchema,
  pricing: pricingStepSchema,
  financeMenu: financeMenuStepSchema,
  reviewSend: reviewSendStepSchema,
});
